<div class="label-section" #broadband>
    <div class="label-broadband">
        <div class="broadband {{page}}" [ngClass]="{ 'read-broadband-label': expanded }">
            <ng-content></ng-content>
        </div>
    </div>
    <div class="label-cta" (click)="toggleSection(broadband)">
        <button [ngClass]="{ 'read': expanded }">
            {{ footerText }}
            <xm-media-image aria-hidden="true" class="arrow" [ngClass]="{ 'expanded': expanded }" [imageOptions]="imageOptions" center="vert" size="height"></xm-media-image>
        </button> 
    </div>
</div>
